/** A referential list of modes: no tenant, no parameter. */
class FetchSsoModes {
	constructor() {
		Object.freeze(this);
	}
}

export default FetchSsoModes;
